import React, { useState, useEffect, useRef, useContext } from "react";
import i18n from "i18next";
import { Link } from "gatsby";
import b3ES from "../../images/home/BannerHome/ES/Banner carrousel home Enero-02.jpg";
import b3EN from "../../images/home/BannerHome/EN/Banner carrousel home Enero-06.jpg";
import b5ES from "../../images/home/BannerHome/ES/Banner carrousel home Enero-01.jpg";
import b6ES from "../../images/home/BannerHome/ES/Banner carrousel home Enero-03.jpg";
import b7ES from "../../images/home/BannerHome/ES/Banner carrousel home Enero-04.jpg";
import b5EN from "../../images/home/BannerHome/EN/Banner carrousel home Enero-05.jpg";
import b6EN from "../../images/home/BannerHome/EN/Banner carrousel home Enero-07.jpg";
import b7EN from "../../images/home/BannerHome/EN/Banner carrousel home Enero-08.jpg";

import { LoadingContext } from "../context/LoadingContext";

const MainBannerHome = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [images, setImages] = useState([]);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [dragOffset, setDragOffset] = useState(0);
  const { windowWidth } = useContext(LoadingContext);
  const trackRef = useRef(null);

  useEffect(() => {
    const banners = i18n.language === "es"
      ? [
        { image: b5ES, link: "/contact-us" },
        { image: b3ES, link: "/service-expansion#licency" },
        { image: b6ES, link: "/service-expansion" },
        { image: b7ES, link: "/exclusive-products" },
      ]
      : [
        { image: b5EN, link: "/contact-us" },
        { image: b3EN, link: "/service-expansion#licency" },
        { image: b6EN, link: "/service-expansion" },
        { image: b7EN, link: "/exclusive-products" },
      ];
    setImages(banners);
  }, [i18n.language]);


  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 10000);
    return () => clearInterval(interval);
  }, [images]);

  const handleDotClick = (index) => setCurrentIndex(index);

  const handleDragStart = (e) => {
    setIsDragging(true);
    setStartX(e.type === "mousedown" ? e.clientX : e.touches[0].clientX);
  };

  const handleDragMove = (e) => {
    if (isDragging) {
      const currentX = e.type === "mousemove" ? e.clientX : e.touches[0].clientX;
      setDragOffset(currentX - startX);
    }
  };

  const handleDragEnd = () => {
    setIsDragging(false);
    if (dragOffset > 50) {
      setCurrentIndex((prevIndex) =>
        prevIndex === 0 ? images.length - 1 : prevIndex - 1
      );
    } else if (dragOffset < -50) {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }
    setDragOffset(0);
  };

  return (
    <div
      className="main-banner-container"
      onMouseDown={handleDragStart}
      onMouseMove={handleDragMove}
      onMouseUp={handleDragEnd}
      onMouseLeave={handleDragEnd}
      onTouchStart={handleDragStart}
      onTouchMove={handleDragMove}
      onTouchEnd={handleDragEnd}
    >
      <div
        ref={trackRef}
        className="carousel-track"
        style={{
          transform: `translateX(calc(-${currentIndex * 100}% + ${dragOffset}px))`,
          transition: isDragging ? "none" : "transform 0.2s ease",
        }}
      >
        {images.map((item, index) => (
          <div key={index} className="banner-slide">
            {item.link.startsWith("http") ? (
              <a href={item.link} target="_blank" rel="noopener noreferrer">
                <img src={item.image} alt={`Slide ${index}`} />
              </a>
            ) : (
              <Link to={item.link}>
                <img src={item.image} alt={`Slide ${index}`} />
              </Link>
            )}
          </div>
        ))}
      </div>

      <div className="dots-container">
        {images.map((_, index) => (
          <span
            key={index}
            className={`dot ${index === currentIndex ? "active" : ""}`}
            onClick={() => handleDotClick(index)}
          ></span>
        ))}
      </div>
    </div>
  );
};

export default MainBannerHome;
